import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	composerTitle: {
		id: 'app.components.SessionPlayer.composerTitle',
		defaultMessage: 'COMPOSER',
		description: 'A descriptor of who composed a piece of music',
	},
	authorTitle: {
		id: 'app.components.SessionPlayer.authorTitle',
		defaultMessage: 'AUTHOR',
		description: 'Descriptor for who authored a particular story',
	},
	narratorTitle: {
		id: 'app.components.SessionPlayer.narratorTitle',
		defaultMessage: 'NARRATOR',
		description: 'Descriptor for who is narrating a story',
	},
	instructorTitle: {
		id: 'app.components.SessionPlayer.instructorTitle',
		defaultMessage: 'INSTRUCTOR',
		description: 'Descriptor for who is instructing a story',
	},
	hostTitle: {
		id: 'app.components.SessionPlayer.hostTitle',
		defaultMessage: 'HOST',
		description: 'Descriptor for who is the host of the content',
	},
	artistTitle: {
		id: 'app.components.SessionPlayer.artistTitle',
		defaultMessage: 'ARTIST',
		description: 'Descriptor for who is the artist of the content',
	},
	guestTitle: {
		id: 'app.components.SessionPlayer.guestTitle',
		defaultMessage: 'GUEST',
		description: 'Descriptor for who is the host of the content',
	},
});
